<template>
  <div class="h-dialogContainer">
    <div class='dp-left-width'>
      <ServerDetailLeft :detailShowList="detailShowList" :showAll="false" :detailInfo="detailInfo"></ServerDetailLeft>
    </div>
    <div class='dp-right-width'>
      <form :id="formId">
      <!--<div class='col-sm-12 h-col-inputBox'>-->
        <!--<div class='h-inputLit'>环境:</div>-->
        <!--&lt;!&ndash;<ejs-dropdownlist disabled="true"></ejs-dropdownlist>&ndash;&gt;-->
        <!--<ejs-textbox name='environment' v-model="deployInfo.runEnvironment" disabled="true"></ejs-textbox>-->
      <!--</div>-->
      <!--<div class='col-sm-12 h-col-inputBox'>-->
        <!--<div class='h-inputLit'><span class="h-red-code">*</span>节点id:</div>-->
        <!--<ejs-textbox name='podId' ref="podId" placeholder="请输入节点id" maxLength="10"></ejs-textbox>-->
      <!--</div>-->
      <div class='col-sm-12 h-col-inputBox'>
        <div class='h-inputLit'><span class="h-red-code">*</span>{{$t('DeployManagement.nodeName')}}:</div>
        <ejs-textbox name='name' v-model="deployInfo.name" maxLength="100"></ejs-textbox>
      </div>
      <div class='col-sm-12 h-col-inputBox'>
        <div class='h-inputLit'><span class="h-red-code">*</span>{{$t('DeployManagement.parentNode')}}:</div>
        <ejs-dropdownlist name='parent' :dataSource="nodeData" :fields="fields" v-model="defaultNode"></ejs-dropdownlist>
      </div>
      <!--<div class='col-sm-12 h-col-inputBox'>-->
        <!--<div class='h-inputLit'>实例名称:</div>-->
        <!--<ejs-textbox name='name' v-model="deployInfo.dname" disabled="true"></ejs-textbox>-->
      <!--</div>-->
      <div class='col-sm-12 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Topo.serviceName')}}:</div>
        <ejs-textbox name='serviceName' v-model="deployInfo.typeValue" disabled="true" ></ejs-textbox>
      </div>
      <div class='col-sm-12 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('DeployManagement.dpCopyCount')}}:</div>
        <ejs-textbox name='count' v-model="deployInfo.dpCount" disabled="true"></ejs-textbox>
      </div>
      <div class='col-sm-12 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('DeployManagement.deployedDesc')}}:</div>
        <ejs-textbox name='description' v-model="deployInfo.description" maxLength="100"></ejs-textbox>
      </div>
      </form>
    </div>
  </div>
</template>

<script>
import ServerDetailLeft from '../ServerDetailLeft';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: "ExpandPocDialog",
  components: {
    ServerDetailLeft
  },
  data() {
    return {
      formId: 'expendPocFormId',
      detailShowList: [
        { name: 'description', value: 'test'},
        { name: 'deliverType', value: '222222'},
        { name: 'createTime', value: '2020-05-23 10:00:10'},
        { name: 'pkgVersion', value: 'tetst'},
      ],
      deployInfo: {
        runEnvironment: '',
        dname: '',
        dpCount: 1,
        description: '',
        dpId: '',
        // podId: ''
      },
      nodeData: [],
      fields: {
        text: 'k8sNodeId',
        value: 'k8sNodeId'
      },
      defaultNode: '',
      validateObj: undefined,
      detailInfo: {
        serviceName: '3333'
      }
    };
  },
  methods: {
    initValue(data = {}) {
      console.log(JSON.stringify(data))
      if (data) {
        data.description = data.description? data.description.trim():data.description;
        this.detailShowList = [
          { name: this.$t('DeployManagement.description'), value: data.description},
          { name: this.$t('DeployManagement.deliverTypeStr'), value: data.deliverTypeStr},
          { name: this.$t('DeployManagement.createTime'), value: new Date(data.createTime).Format('yyyy-MM-dd HH:mm:ss')},
          { name: this.$t('DeployManagement.pkgVersion'), value: data.version},
        ];
        this.deployInfo = data;
        this.detailInfo.serviceName = data.typeValue;
        const param = {
          envID: data.envID
        };
        const url = '/lte/ems/deployed/qryNodeList';
        // 查询所有node节点----根据环境
        this.$axios.post(url, param).then((res) => {
          if (res.data && res.data.resultVal) {
            this.nodeData = res.data.resultVal;
            this.defaultNode = this.nodeData[0].k8sNodeId;
          }
        })
      }
    },
    getData() {
      return this.deployInfo;
    },
    saveExpendPoc(data, callbackFun) {
      const url = '/lte/ems/deployed/expendPoc';
      const param = data[0];
      // param.count = this.deployInfo.dpCount;
      param.description = param.description? param.description.trim():param.description;
      param.parent = this.defaultNode;
      param.name = this.deployInfo.name;
      // param.podId = this.$refs.podId._data.ej2Instances.value;
      if(!this.checkValid()) {
        return;
      }
      this.$loading.showLoadding(this.$t('MML.loadingTip'));
      this.$axios.post(url, param).then((response) => {
        this.$loading.hideLoadding();
        if (callbackFun) {
          callbackFun(response);
        }
      })
    },
    bindValidate() {
      const validationOption = {
        customPlacement(inputElement, errorElement) {
          errorElement.style.position = 'fixed';
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          // podId: {
          //   required: [true, this.$t('Alarm.fieldIsRequired')],
          //   regex: ['^\\d*$', this.$t('SubscriberIms.invalidInt')],
          //   maxLength: [10, this.$t('DeployManagement.charLimit').format(10)],
          //   range: [[1, 4294967295], this.$t('DeployManagement.charLimit').format(1, 4294967295)],
          // },
          name: {
            required: [true, this.$t('Alarm.fieldIsRequired')],
            // regex: ['^[ _0-9a-zA-Z\\.\u4E00-\u9FA5]+$', this.$t('SubscriberIms.invalideChar')],
            maxLength: [256, this.$t('DeployManagement.charLimit').replace('{0}','100')],
          },
          description: {
            // regex: ['^[ _0-9a-zA-Z\u4E00-\u9FA5]+$', this.$t('SubscriberIms.invalideChar')],
            maxLength: [256, this.$t('DeployManagement.charLimit').replace('{0}','100')],
          }
        },
      };
      this.validateObj = new FormValidator(`#${this.formId}`, validationOption);
    },
    checkValid() {
      const checkStatus = this.validateObj.validate();
      console.log("checkStatus=",checkStatus);
      return checkStatus;
    },
  },
  computed() {

  }
};
</script>
<style scoped>
  .h-dialogContainer{
    height:100%;width:100%;
  }

</style>
